/* Balise — améliorations de lecture des articles de blog
   1. Enveloppe les tableaux pour les rendre scrollables sur mobile
   2. Ajoute des ancres sur les h2
   3. Génère un sommaire cliquable quand l'article compte au moins 4 sections */
(function () {
  var root = document.querySelector('.blog-post-content');
  if (!root) return;

  var content = root.querySelector('rte-formatter') || root;

  content.querySelectorAll('table').forEach(function (table) {
    if (table.parentElement && table.parentElement.classList.contains('table-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'table-wrap';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  var slugify = function (text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  };

  var headings = Array.prototype.filter.call(
    content.querySelectorAll('h2'),
    function (h) {
      return !h.closest('.balise-cta') && h.textContent.trim().length > 0;
    }
  );

  var used = {};
  headings.forEach(function (h) {
    if (h.id) return;
    var base = slugify(h.textContent.trim()) || 'section';
    var id = base;
    var i = 2;
    while (used[id] || document.getElementById(id)) {
      id = base + '-' + i++;
    }
    used[id] = true;
    h.id = id;
  });

  if (headings.length < 4) return;
  if (content.querySelector('.balise-toc')) return;

  var nav = document.createElement('nav');
  nav.className = 'balise-toc';
  nav.setAttribute('aria-label', 'Sommaire');

  var title = document.createElement('p');
  title.className = 'balise-toc__title';
  title.textContent = 'Au sommaire';
  nav.appendChild(title);

  var list = document.createElement('ol');
  headings.forEach(function (h) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
  });
  nav.appendChild(list);

  var anchor = content.querySelector('.balise-callout') || content.querySelector('p');
  if (anchor && anchor.parentNode) {
    anchor.parentNode.insertBefore(nav, anchor.nextSibling);
  }
})();
